import React from 'react';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogActions, Divider } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    ...theme.component.dialogPaper,
    overflowY: 'auto',
  },
  dialogContent: {
    margin: '0 auto',
    //maxWidth: '780px',
    overflowY: 'visible',
    width: '100%',
  },
}));

function FullScreenDialog(props) {
  const classes = useStyles();
  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <Dialog
      disableBackdropClick
      fullScreen={props.fullScreen ? true : !upSm}
      fullWidth
      classes={{ paper: classes.dialogPaper }}
      open={
        'open' in props ? props.open : props.openDialog === props.dialogName
      }
      onClose={props.onClose}
    >
      <DialogHeader
        onClose={props.onClose}
        title={props.title}
        collapse={props.collapse}
      />
      <DialogContent className={classes.dialogContent}>
        {props.children}
      </DialogContent>
      {props.footer && (
        <>
          <Divider />
          <DialogActions>{props.footer}</DialogActions>
        </>
      )}
    </Dialog>
  );
}

FullScreenDialog.defaultProps = {
  fullScreen: true,
};
export default FullScreenDialog;
